import { useContext, useEffect, useState } from "react";
import AnimatedNumber from "react-animated-number";
import {
  DiscountAmount,
  DiscountText,
  DwebWrapper,
  ParentWrapper,
  SavingAmount,
  SavingText,
  SavingWrapper,
  Wrapper
} from "./styles";
import { Context } from "@components/useContext/context";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import { useDispatch, useSelector } from "react-redux";
import { getInrFormat } from "@utils/inrFormatter";
import Lottie from "lottie-react";
import { LottieConstants } from "../Lottie/animations";
import React from "react";
import {
  skipLottieAnimation,
  updateLottieAnimationLoopCompletedd
} from "@store/slices/lottieState";

const CouponDiscountAnimation = (props) => {
  const dispatch = useDispatch();
  const [isAnimationDoneOnce, setIsAnimationDoneOnce] =
    useState<boolean>(false);
  const { isDesktop } = useContext(Context);
  const [initialAnimationKey, setInitialAnimationKey] =
    useState<string>("CONGRATS_ANIMATION");

  const {
    isLoading,
    netPremium,
    mk,
    discountApplied,
    redirectionDone,
    nextNodeSuccess,
    showLottie
  } = useSelector(({ configuration, lottieState }: any) => {
    return {
      isLoading: configuration?.isLoading,
      netPremium: configuration?.netPremium,
      mk: configuration?.lottieAnimationLoopCompleted,
      discountApplied: configuration?.discountApplied,
      redirectionDone: lottieState.redirectionDone,
      nextNodeSuccess: lottieState.nextNodeSuccess,
      showLottie: lottieState?.showLottie
    };
  });
  // TO FIRST SHOW THE CONGRATS ANIMATION THEN DISCOUNT ANIMATION
  const isInitialAnimation = initialAnimationKey === "CONGRATS_ANIMATION";

  const handleLottieCycleComplete = () => {
    if (isInitialAnimation) {
      setInitialAnimationKey("DISCOUNT_ANIMATION");
    } else if (isAnimationDoneOnce) {
      if (nextNodeSuccess) {
        dispatch(
          updateLottieAnimationLoopCompletedd({
            lottieAnimationLoopCompleted: true
          })
        );
        if (redirectionDone) {
          dispatch(skipLottieAnimation({ showLottie: false }));
        }
      }
    }
  };

  console.log("coupon animation", isLoading, isAnimationDoneOnce, mk);

  const handleAnimationComplete = (percentage) => {
    if (percentage === 100) {
      setIsAnimationDoneOnce(true);
      // since lottieAnimationLoopCompleted is needed to render page thus
      // mocking it as default true since in this case lottie is not played
      // setTimeout(() => {
      //   dispatch(
      //     updateLottieAnimationLoopCompleted({
      //       lottieAnimationLoopCompleted: true
      //     })
      //   );
      //   dispatch(skipLottieAnimation({ showLottie: false }));
      // }, 1000);
    }
  };
  const lottieStyles = {
    width: "160px",
    height: "160px"
  };

  const initalAnimationStyles = {
    width: "300px",
    height: "300px"
  };

  return (
    <>
      {!isDesktop && <DwebWrapper />}
      <ParentWrapper isDesktop={isDesktop}>
        <Wrapper isDesktop={isDesktop}>
          <Lottie
            animationData={LottieConstants[initialAnimationKey]}
            loop={true}
            style={isInitialAnimation ? initalAnimationStyles : lottieStyles}
            autoplay={true}
            onLoopComplete={handleLottieCycleComplete}
          // onComplete={handleLottieOnComplete}
          />
          {!isInitialAnimation && (
            <>
              <DiscountText>Your discounted premium is</DiscountText>
              <Flex
                flexDirection="row"
                style={{ alignContent: "center", justifyContent: "center" }}
              >
                <DiscountAmount>₹</DiscountAmount>
                <AnimatedNumber
                  value={netPremium}
                  style={{
                    color: "#451999",
                    textAlign: "center",
                    fontFamily: '"Euclid Circular B"',
                    fontSize: "32px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "44px",
                    letterSpacing: "-0.5px",
                    transition: "0.8s ease-out",
                    transitionProperty: "background-color, color, opacity"
                  }}
                  formatValue={(n) => n?.toFixed(0)}
                  frameStyle={(percentage) =>
                    handleAnimationComplete(percentage)
                  }
                  duration={2000}
                  initialValue={0}
                />
              </Flex>
              <SavingWrapper>
                <SavingText>Total savings - </SavingText>
                <SavingAmount>
                  {getInrFormat(discountApplied, true)}
                </SavingAmount>
              </SavingWrapper>
            </>
          )}
        </Wrapper>
      </ParentWrapper>
      <style jsx>
        {`
          .animated-price {
            color: green;
          }
        `}
      </style>
    </>
  );
};

export default CouponDiscountAnimation;
